import { render, staticRenderFns } from "./TaskDefinitionList.vue?vue&type=template&id=1ac87d9c&"
import script from "./TaskDefinitionList.vue?vue&type=script&lang=js&"
export * from "./TaskDefinitionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports